import { useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "./SecurityBits";

const EMPTY = { current: "", next: "", confirm: "" };

/** Form state + validation + submit for the admin "change password" flow. */
export function useChangePassword(refresh) {
  const [form, setForm] = useState(EMPTY);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const { current, next, confirm } = form;

  const mismatch = confirm.length > 0 && confirm !== next;
  const sameAsCurrent = next.length > 0 && next === current;
  const canSubmit = Boolean(current) && next.length >= 10 && confirm === next && !sameAsCurrent && !busy;
  const setField = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  async function submit(e) {
    e.preventDefault();
    setErr(""); setOk("");
    if (next.length < 10) return setErr("New password must be at least 10 characters.");
    if (sameAsCurrent) return setErr("New password must be different from the current one.");
    if (next !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: current, new_password: next });
      setForm(EMPTY);
      setOk(`Password updated ${fmtDate(r.data.password_changed_at)} · every other session has been signed out; this device stays signed in.`);
      refresh();
    } catch (e2) {
      const d = e2.response?.data?.detail;
      setErr(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Password change failed.");
    } finally {
      setBusy(false);
    }
  }

  return { form, setField, show, toggleShow: () => setShow((s) => !s), busy, err, ok, mismatch, sameAsCurrent, canSubmit, submit };
}
